import moment from 'moment';
moment.locale('ru');

export default (value, format = 'DD MM YYYY') => {
    return moment(value).format(format);
};